var toString$2 = {}.toString;
var isType = function (value, type) { return toString$2.call(value) === '[object ' + type + ']'; };

export { isType as default };
//# sourceMappingURL=is-type.js.map
